import {UNIT_TYPE} from "../../support/UnitType";
import React from "react";

export const UnitTitle = ({customUnitId, unit}) => {
  if (!unit) return null;

  return (<div className="flex items-center space-x-2 mb-3">
    <h5 className="font-medium text-sm">
      {customUnitId || unit.display_name}
    </h5>
    <span className="px-2 py-1 text-xs rounded-full" style={{
      backgroundColor: UNIT_TYPE[unit.unit_type].color,
      color: 'white'
    }}>
            {UNIT_TYPE[unit.unit_type].label}
          </span>
  </div>);
}